const include = (array, value) => {
  return array.indexOf(value) > -1
}

module.exports = include



// WEBPACK FOOTER //
// ../node_modules/berries/lib/include.js